import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const FormRow = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
}))
